<template>
  <div>
    <div class="content">
      <div class="container">
        <div><img src="https://file.lgbfss.com/www/official/images/lock1.jpg" alt="" />重置密码</div>
        <div>
          <span>1</span>
          <span>手机号验证</span>
          <span class="line">————————————————————</span>
          <span>2</span>
          <span>重新设置密码</span>
          <span class="line">————————————————————</span>
          <span>3</span>
          <span>重置密码成功</span>
        </div>
        <div class="text-align-center">
          <form action="">
            <div>
              <input type="text" placeholder="请输入绑定手机号" />
            </div>
            <div>
              <input type="text" placeholder="请输入短信验证码" style="width:300px;"/>
              <span class="get-sms">获取验证码</span
              >
            </div>
          </form>
          <button>下一步</button>
          <div>返回登录界面</div>
        </div>
        <div class="text-align-center">
          <form action="">
            <div>
              <input type="text" placeholder="设置密码" />
            </div>
            <div>
              <input type="text" placeholder="确认密码" />
            </div>
          </form>
          <button>确认修改</button>
        </div>
        <div class="text-align-center">
          <div>密码重置成功，请使用新密码重新登录</div>
          <button>重新登录</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "find_pwd",
};
</script>

<style lang="css" scoped>
.text-align-center {
  text-align: center;
}
button {
  border: none;
  padding: 12px 180px;
  color: #fff;
  background-color: #64cdff;
  margin: 20px 0 8px 0;
  border-radius: 10px;
  outline: none;
  cursor: pointer;
  font-size: 14px;
}
.line {
  color: #d5d5d5;
  padding: 0 12px;
}
input{
    width: 402px;
    border: none;
    background-color: #f6f8fb;
    height: 45px;
    border-radius: 6px;
}
form>div{
    margin: 20px 0;
}
.get-sms{
    display: inline-block;
    line-height: 45px;
    background-color: #64cdff;
    color: #fff;
}
</style>
